module.exports = __webpack_public_path__ + "img/profitable-img-mobile-4.f310a64f.png";